<template>
    <div class="layout-container">
        <layout-header/>
        <div class="layout-content">
            <div class="layout-table-header">
                <div class="title-group">
                    <span class="layout-title">Account unification</span>
                    <span class="items-count" v-text="displayItemsCount"></span>
                </div>
                <pagination :number-of-page="numberOfPage"/>
            </div>
            <table>
                <layout-search/>
                <tr>
                    <th></th>
                    <th>E-mail</th>
                    <th>First name</th>
                    <th>Last name</th>
                    <th class="center">Is active</th>
                    <th class="center">Compliance</th>
                    <th class="center">DFS</th>
                    <th class="center">Academy</th>
                </tr>
                <tr v-if="loadingState">
                    <td colspan="8" class="loader-row">
                        <loader class="color"/>
                    </td>
                </tr>
                <template v-else>
                    <account-unification-item v-for="item in items" v-bind:key="item.id" :init-data="item"/>
                </template>
            </table>
            <account-unification-bulk-action/>
        </div>
    </div>
</template>

<script>
    import LayoutHeader from "../layouts/LayoutHeader";
    import Pagination from "../components/Pagination";
    import LayoutSearch from "../layouts/LayoutSearch";
    import AccountUnificationItem from "./AccountUnificationItem";
    import AccountUnificationBulkAction from "./AccountUnificationBulkAction";
    import {mapGetters, mapMutations} from "vuex";
    import Loader from "../components/Loader";
    import AuthService from "../../new/services/AuthService";

    export default {
        name: "AccountUnification",
        components: {
            Loader,
            AccountUnificationBulkAction, AccountUnificationItem, LayoutSearch, Pagination, LayoutHeader
        },
        computed: {
            displayItemsCount() {
                return '(' + this.itemsCount + ')';
            },
            ...mapGetters('app', {
                itemsCount: 'getItemsCount',
                numberActivePage: 'getNumberActivePage',
                numberOfPage: 'getNumberOfPage',
                searchValue: 'getSearchValue',
            })
        },
        data() {
            return {
                items: [],
                loadingState: false,
                timer: null,
            }
        },
        methods: {
            ...mapMutations('app', {
                clearSelectedItems: 'clearSelectedItems',
                setItemsCount: 'setItemsCount',
                setNumberActivePage: 'setNumberActivePage',
                setNumberOfPage: 'setNumberOfPage',
            }),
            initUsers(firstPage) {
                this.loadingState = true;

                if (firstPage) {
                    this.setNumberActivePage(1);
                }

                this.$api.usersIndex({
                    data: {
                        'page': this.numberActivePage,
                        'perPage': 20,
                        'search': this.searchValue,
                    }
                }).then(({data}) => {
                    this.items = data.data;
                    this.setItemsCount(data.resultsCount);
                    this.setNumberOfPage(data.totalPages);
                    this.loadingState = false;
                });
            }
        },
        mounted() {
            if (!AuthService.isLogged()) {
                this.$router.push(this.$enums.RoutePathEnum.LOGIN);
            }

            this.clearSelectedItems();
            this.initUsers(true);
        },
        watch: {
            numberActivePage() {
                if (this.timer !== null) {
                    clearTimeout(this.timer);
                }

                this.timer = setTimeout(() => {
                    this.initUsers(false);
                    this.timer = null;
                }, 300)
            },
            searchValue() {
                this.initUsers(true);
            }
        }
    }
</script>